import { Entity, type EntityProps } from '../../../core/context/entity';
import { UUID } from '../../../core/context/uuid/entity';

export enum AssumptionValidated {
    NO = 'NO',
    NoCreateTask = 'NO_CREATE_TASK',
    ValidationPending = 'VALIDATION_PENDING',
    YES = 'YES',
}

export const assumptionValidatedMap: Record<AssumptionValidated, string> = {
    [AssumptionValidated.NO]: 'No',
    [AssumptionValidated.NoCreateTask]: 'No (task not created)',
    [AssumptionValidated.ValidationPending]: 'Validation pending',
    [AssumptionValidated.YES]: 'Yes',
};

export interface AssumptionProps extends EntityProps {
    description: string;
    responsibleId: string;
    validated: AssumptionValidated;
    validationDate?: Date;
    taskRef?: string;
    taskUpdated?: string;
}

export class Assumption extends Entity implements AssumptionProps {
    description: string;
    responsibleId: string;
    validated: AssumptionValidated;
    validationDate?: Date;
    taskRef?: string;
    taskUpdated?: string;

    constructor({
        id,
        name,
        description,
        responsibleId,
        validationDate,
        validated,
        taskRef,
        taskUpdated,
    }: AssumptionProps) {
        super({ id, name });
        this.description = description;
        this.responsibleId = responsibleId;
        this.validated = validated;
        this.validationDate = validationDate;
        this.taskRef = taskRef;
        this.taskUpdated = taskUpdated;

        if (
            this.validated === AssumptionValidated.NoCreateTask &&
            !this.validationDate
        ) {
            throw new Error(
                'Assumption with NoCreateTask validation must have a validation date.',
            );
        }
    }

    static new(props: Omit<Omit<AssumptionProps, 'id'>, 'files'>): Assumption {
        return new Assumption({
            id: new UUID().toString(),
            ...props,
        });
    }
}
